export const sortByOptions = [
  'PRIORITY',
  'REFERENCE',
  'DEBTOR_ACCOUNT',
  'DEBTOR_NAME',
  'AMOUNT',
  'CURRENCY',
  'EXECUTION_DATE',
  'CREDITOR_ACCOUNT',
  'CREDITOR_NAME',
  'CHARGES',
  'STATUS',
] as const;
